import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';

export interface tabledata {
  repaginate: boolean;
  status: string;
  sequence: number;
  formid: string;
  formtitle: string;  
  description?: string;
  instructions? : string;
  editable: string;
}

const data: tabledata [] = [
  {
    repaginate: true,
    status : "To Be Generated",
    sequence: 1,
    formid: 'NA- Cover Page',
    formtitle: 'Cover Page NA',
    description: '',
    instructions : '',
    editable: 'N',
  },
  {
    repaginate: true,
    status : "To Be Generated",
    sequence: 2,
    formid: 'US-FAC-REINSURANCE-CERTIFICATE-EN',
    formtitle: 'Facultative Reinsurance Certificate',
    description: '',
    instructions : '',
    editable: 'Y',
  },
  {
    repaginate: true,
    status : "To Be Generated",
    sequence: 3,
    formid: 'WW-FAC-REINSURANCE-CERTIFICATE-US-CAN-EN',
    formtitle: 'Facultative Reinsurance Certificate(US-CAN)',
    description: '',
    instructions : '',
    editable: 'N',
  }
];

@Component({
  selector: 'cmpts-stepper',
  templateUrl: './stepper.component.html',
  styleUrls :['./stepper.component.css']
})
export class StepperComponent implements OnInit {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  isEditable = false;  
  columns : string[] = ['select','repaginate','status','sequence','formid','formtitle','description','instructions','editable'];
  dataSource = new MatTableDataSource<tabledata>(data);    
  selection = new SelectionModel<tabledata>(true, []);
  isShow = true;  
  showStepper = false;
  @Output() onSave = new EventEmitter<any>();
  @âViewChild('stepper') stepper: MatStepper;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor() { }

  ngOnInit(): void {        
    this.dataSource.sort = this.sort;      
    this.dataSource.paginator= this.paginator;
    if(window.innerWidth <= 600) 
      this.showStepper = true ;
    else
      this.showStepper = false;
  }

  ngAfterViewInit (){
    this.dataSource.sort = this.sort;   
    this.dataSource.paginator= this.paginator;
  }

  onGenerateButton(index: number,stepper: MatStepper, event) {
    stepper.selectedIndex =index-1;
    event.preventDefault();
  }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;     
      return numSelected === numRows;
    }
  
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
      if(this.isAllSelected())
      {
        this.selection.clear() ;
        this.isShow = false;
        this.toggleDisplay();
      }
      else
      {  
        this.dataSource.data.forEach(row => this.selection.select(row));
        this.isShow = true;
        this.toggleDisplay();      
      }
    }
  
    toggleDisplay() {
      this.isShow = !this.isShow;
    }
  
    CheckBoxChanged(model: any) {
      const numSelected = this.selection.selected.length;   
  
      if (model.checked == true) {      
        this.isShow = true;
      } else {
          this.isShow = false;
      }
      this.toggleDisplay();   
    } 

    onResize1(event) {
      if(event.target.innerWidth <= 600)
        this.showStepper = true ;
      else
        this.showStepper = false;
    }

    onSaveButton(event) {
      this.onSave.emit(event);
    }

    onbuttonclick(event){
      event.preventDefault();
    }
  

}
